<template>
 <div data-v-63f47ea8="" data-v-e5781868="" class="superPartner mainContent top50">
				<div data-v-63f47ea8="" class="banner"><img data-v-63f47ea8="" src="/static/image/banner.148afb4d.jpg"></div>
				<div data-v-63f47ea8="" class="main">
					<div data-v-63f47ea8="" class="content">
						<div data-v-63f47ea8="" class="box">
							<h1 data-v-63f47ea8="">什么是超级合伙人?</h1>
							<p data-v-63f47ea8="">{{$store.state.appInfo.title}}超级合伙人是一种无门槛、高回报的优惠礼金活动，成为{{$store.state.appInfo.title}}合伙人可享有共三级的现金奖励，邀请来的对象可以享有一级的现金奖励，而邀请来的对象再介绍的还可享受二级的现金奖励，然而奖励还并没有结束！二级好友介绍来的好友还可再享有三级的现金奖励！</p>
							<p data-v-63f47ea8="" class="text2">超级合伙人为长期有效活动，多多呼朋唤友一起玩耍吧！礼金多多，奖励多多</p>
						</div>
					</div>
				</div>
			</div>
</template>
<script>
export default {
  name: 'details',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    //弹出登录框
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    //弹出注册框
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    //弹出忘记密码框
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    //首页banner
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    //首页时间轴品牌历程
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    //盈利榜
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
    //页面tab切换
$('.navigation ul li').click(function() {
	var index=$(this).index();
	$('.tabcon').eq(index).slideDown(300).siblings().slideUp(0);
	$(this).addClass('active').siblings().removeClass('active');
	$('html,body').animate({scrollTop:$('.navigation').offset().top},500);
});

//常见问题展开详情
$('.accordion .group').click(function() {
	$(this).find('.t .arrow').toggleClass('arrow-d');
	$(this).find('.a-row').slideToggle(0);
});
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-6cc178e1.70a3ba40.css';
@import '../../../static/css/chunk-009dfcc3.a4bf2976.css';
@import '../../../static/css/chunk-1225a5b6.b06a16a7.css';
@import '../../../static/css/chunk-639bacf2.80f975ef.css';
@import '../../../static/css/chunk-1bfc786f.3344e98f.css';
@import '../../../static/css/chunk-9c01ee94.ae6edd11.css';
@import '../../../static/css/chunk-4a9bbb2b.cbe5dff6.css';
@import '../../../static/css/chunk-5c0f8190.3a9f340c.css';

 .faq .faq-container .row .group .a-row[data-v-3ecdc100] {
          display: none;
        }
</style>



// WEBPACK FOOTER //
// src/components/allMode/details.vue